import { gql } from "@/gql/__generated__";
import { UserMembershipsQuery } from "@/gql/__generated__/graphql";
import { ArrayElement } from "@/lib/ts-helpers/ArrayElement";
import { useQuery } from "@apollo/client";

export const GET_USER_MEMBERSHIPS = gql(`
  query userMemberships {
    me {
      id
      memberships {
        id
        role
        organization {
          id
          name
          slug
          createdAt
        }
      }
    }
  }
`);

export const useGetUserMemberships = () => {
  const { data, ...rest } = useQuery(GET_USER_MEMBERSHIPS, {
    fetchPolicy: "cache-and-network"
  });

  const memberships = data?.me.memberships || [];

  return { ...rest, data: memberships };
};

export type OrganizationMembership = ArrayElement<
  UserMembershipsQuery["me"]["memberships"]
>;
